import _ from "lodash";
import Vue from "vue";

export const Mutations = {
    loadPartsSearchLocation(state, ui) {
      state.partsSearchLocations = ui;
    },
    setPlannerBoardType(state, ui) {
        state.plannerBoardType = ui;
    },
    changeUpdateStatus(state, ui) {
        state.isCanUpdate = ui;
    },
    loadUsers(state, ui) {
        state.users = ui;
    },
    loadStatuses(state, ui) {
        state.ceStatuses = ui;
    },
    setPcs(state, ui) {
        state.pcs = ui;
    },
    setScannerApiKey(state, ui) {
        state.scannerApiKey = ui;
    },
    auth_request(state) {
        state.status = 'loading';
    },
    cameraCountIncrease(state) {
        state.cameraCount++
    },
    auth_success(state, token) {
        state.status = 'success';
        state.token = token;
    },
    auth_error(state) {
        state.status = 'error';
    },
    logout(state) {
        state.isLogout = true;
        state.status = '';
        state.token = '';
    },

    setCardFilter(state, filter) {
        state.filter.card = filter;
    },
    setInvoiceFilter(state, filter) {
        state.filter.invoice = filter;
    },
    setJustSeeMine(state, val) {
        state.userInfo.isJustSeeMine = val;
    },
    setEstimateFilter(state, filter) {
        state.filter.estimate = filter;
    },

    loadVehiclesForCustom(state, mm) {
        //state.vehiclesForCustom = mm;
    },
    loadVehicleScheduleNumbers(state, mm) {
        state.vehicleScheduleNumbers = mm;
    },
    loadVehicleMakeModels(state, mm) {
        state.vehicleMakeModels = mm;
    },
    loadVehicleMakeModelsBike(state, ui) {
        state.vehicleMakeModelsBike = ui;
    },
    loadPartCategories(state, prts) {
        state.partCategories = prts;
    },
    loadButterfly(state, data) {
        if (data && data.bodies) {
            state.butterfly.bodies = data.bodies;
        }
        if (data && data.categories) {
            state.butterfly.categories = data.categories;
        }
        if (data && data.customMatrix) {
            state.butterfly.customMatrix = data.customMatrix;
        }
        if (data && data.matrix) {
            state.butterfly.matrix = data.matrix;
        }
        if (data && data.names) {
            state.butterfly.names = data.names;
        }
        if (data && data.matrixOrder) {
            state.butterfly.matrixOrder = data.matrixOrder;
        }
    },
    setButterflyMatrixOrder(state, data) {
        if (!state.butterfly.matrixOrder) {
            Vue.set(state.butterfly, 'matrixOrder', {});
        }
        if (!state.butterfly.matrixOrder[data.bodyId]) {
            Vue.set(state.butterfly.matrixOrder, data.bodyId, {});
        }
        if (!state.butterfly.matrixOrder[data.bodyId][data.type]) {
            Vue.set(state.butterfly.matrixOrder[data.bodyId], data.type, {});
        }
        if (!state.butterfly.matrixOrder[data.bodyId][data.type][data.categoryId]) {
            Vue.set(state.butterfly.matrixOrder[data.bodyId][data.type], data.categoryId, []);
        }
        state.butterfly.matrixOrder[data.bodyId][data.type][data.categoryId] = data.sort;
    },
    addToButterflyCustomMatrix(state, data) {
        if (!state.butterfly.customMatrix) {
            Vue.set(state.butterfly, 'customMatrix', {});
        }
        if (!state.butterfly.customMatrix[data.bodyId]) {
            Vue.set(state.butterfly.customMatrix, data.bodyId, {});
        }
        if (!state.butterfly.customMatrix[data.bodyId][data.type]) {
            Vue.set(state.butterfly.customMatrix[data.bodyId], data.type, {});
        }
        if (!state.butterfly.customMatrix[data.bodyId][data.type][data.categoryId]) {
            Vue.set(state.butterfly.customMatrix[data.bodyId][data.type], data.categoryId, []);
        }
        state.butterfly.customMatrix[data.bodyId][data.type][data.categoryId].unshift(data);
    },
    addItemToJobs(state, item) {
        console.log('addItemToJobs',item);
        let type = item.type
        if (!state.partCategories[type].Custom) {
            Vue.set(state.partCategories[type],'Custom',{});
        }
        item.prt = _.toUpper(item.prt);
        Vue.set( state.partCategories[type].Custom,item.prt,item);
        let newCustomObj=Object.assign({}, state.partCategories[type].Custom)
        Vue.set(state.partCategories[type],'Custom',newCustomObj);
    },
    removeFromButterflyCustomMatrix(state, data) {
        if (!state.butterfly.customMatrix) {
            return;
        }
        if (!state.butterfly.customMatrix[data.bodyId]) {
            return;
        }
        if (!state.butterfly.customMatrix[data.bodyId][data.type]) {
            return;
        }
        if (!state.butterfly.customMatrix[data.bodyId][data.type][data.categoryId]) {
            return;
        }
        state.butterfly.customMatrix[data.bodyId][data.type][data.categoryId] = _.remove(state.butterfly.customMatrix[data.bodyId][data.type][data.categoryId], function (i) {
            return Number(i.id) != Number(data.id);
        });
    },
    removeItemFromJobs(state, item){
        console.log('removeItemFromJobs', item);
        let type = item.type
        if (state.partCategories[type] && state.partCategories[type].Custom) {
            state.partCategories[type].Custom = _.omit(state.partCategories[type]['Custom'], _.toUpper(item.prt));
        }
    },
    loadUserInfo(state, ui) {
        state.userInfo = ui;
        console.log('LOADED.loadUserInfo')
    },
    loadMenu(state, ui) {
        state.menu = ui;
        console.log('LOADED.loadMenu')
    },
    loadVendorInfo(state, ui) {
        state.vendorInfo = ui;
        console.log('LOADED.loadVendorInfo')
    },
    loadBusinessTypes(state, ui) {
        state.businessTypes = ui;
        console.log('LOADED.loadBusinessTypes')
    },
    loadDashboardSummary(state, ui) {
        state.dashboardSummary = ui;
        console.log('LOADED.loadDashboardSummary')
    },
    loadCustomerVehicles(state, ui) {
        state.customerVehicles = ui;
        console.log('LOADED.loadCustomerVehicles')
    },
    removeCustomerVehicles(state, ui) {
        let customerIndex = _.findIndex(state.customerVehicles, (c) => {
            return Number(ui) == Number(c.customer_id)
        })
        if (customerIndex !== -1) {
            state.customerVehicles.splice(customerIndex, 1)
        }
    },
    loadInsurances(state, ui) {
        state.insurers = ui.insurers;
        state.assessors = ui.assessors;
        state.insurances = ui.insurances;
        console.log(state.insurers);
        console.log('LOADED.loadInsurances')
    },

    addFileIdInCardEdit(state, id) {
        state.fileIdsInCardEdit.push(id);
    },

    updateFileIdsInCardEdit(state, idArray) {
        state.fileIdsInCardEdit = idArray;
    },

    clearFileIdsInCardEdit(state) {
        state.fileIdsInCardEdit = [];
    },

    addFileInCardEdit(state, file) {
        state.filesInCardEdit.push(file);
    },

    removeFileIdInCardEdit(state, id) {
        state.fileIdsInCardEdit.splice(id, 1);
    },

    removeFileInCardEditById(state, id) {
        state.filesInCardEdit.splice(id, 1);
    },

    unshiftFileInCardEdit(state, file) {
        state.filesInCardEdit.unshift(file);
    },

    updateFiles(state, files) {
        _.forEach(files, (f) => {
            let orig = _.find(state.filesInCardEdit, (file) => {
                return Number(file.id) == Number(f.id)
            })
            if (orig && orig.isEdit) {
                f.isEdit = true
            }
            if (orig && orig.fileType) {
                f.fileType = orig.fileType
            }
            if (orig && orig.name2) {
                f.name2 = orig.name2
            }
        })
        state.filesInCardEdit = files;
    },

    updateDataInCardEdit(state, {uid, v}) {
        state.updateData[uid] = v;
    },

    deleteUpdateDataByField(state, field) {
        delete state.updateData[field];
    },

    clearUpdateDataByField(state, field) {
        state.updateData[field] = null;
    }
};
